import { HeadersFunction, MetaFunction } from "react-router";
import privacyPolicyData from "~/data/policy/privacy-policy.json";
import { useFontStyle } from "~/hook/useFontStyle";
import { getPageMeta } from "~/lib/helperFuncation/metaHelper";
import { cn } from "~/lib/utils";
import { CACHED_PAGE, FALLBACK_IMAGE_URL, LANG } from "~/utils/constant";
import { computeEtagFromData } from "~/utils/helper-funcations";
import { metaService } from "~/utils/metaService";

export const meta: MetaFunction = ({ location, params }) => {
  const pathname = location?.pathname || "/";
  const lang = params.lang || "en";

  const meta = getPageMeta("privacyPolicy", lang);

  return metaService({
    title: meta.metaTitle,
    description: meta.metaDescription,
    ogTitle: meta.ogTitle,
    ogDescription: meta.ogDescription,
    ogUrl: pathname,
    ogImg: meta.ogImage || FALLBACK_IMAGE_URL,
    ogWidth: meta.ogImageWidth || "1200",
    ogHeight: meta.ogImageHeight || "630",
    canonicalLink: pathname,
    hreflangs: privacyPolicyData.hreflangs.map((lang) => ({
      ...lang,
      href: `${lang.href}${pathname}`,
    })),
  });
};

export const loader = ({ params, request }: { params: { lang: string }; request: Request }) => {
  const lang = params.lang || LANG.english;
  const DATA = {
    title: lang === LANG.english ? "Privacy Policy" : "ગોપનીયતા નીતિ",
  };

  const etag = computeEtagFromData(DATA);
  const ifNoneMatch = request.headers.get("If-None-Match");
  if (ifNoneMatch === etag) {
    return new Response(null, {
      status: 304,
      headers: {
        Etag: etag,
      },
    });
  }
  return Response.json(DATA, {
    headers: { ...CACHED_PAGE.POLICY.HEADERS, ETag: etag },
  });
};

export const headers: HeadersFunction = ({ loaderHeaders }) => loaderHeaders;

function PrivacyPolicy() {
  const { normalInter } = useFontStyle();
  return (
    <div className="text-textColor p-4 rounded-lg font-inter text-16 leading-relaxed space-y-4 max-w-4xl mx-auto">
      <p
        className={cn("text-textSecondaryColor body_text_m", normalInter)}
        dangerouslySetInnerHTML={{ __html: privacyPolicyData.content.introduction }}
      />

      <p className={cn("text-textSecondaryColor body_text_m", normalInter)}>{privacyPolicyData.content.sharingInfo}</p>

      {privacyPolicyData.content.sections.map((section, index) => (
        <div key={index}>
          <h2 className={cn("text-textColor font-semibold", normalInter)}>{section.title}</h2>

          {Array.isArray(section.content)
            ? section.content.map((paragraph, pIndex) => (
                <p key={pIndex} className={cn("text-textSecondaryColor body_text_m", normalInter)} dangerouslySetInnerHTML={{ __html: paragraph }} />
              ))
            : section.content && (
                <p className={cn("text-textSecondaryColor body_text_m", normalInter)} dangerouslySetInnerHTML={{ __html: section.content }} />
              )}

          {section.list && (
            <ul className={`list-${section.listType || "disc"} pl-6`}>
              {section.list.map((item, lIndex) => (
                <li key={lIndex} className={cn("text-textSecondaryColor body_text_m", normalInter)}>
                  {item}
                </li>
              ))}
            </ul>
          )}

          {section.additionalContent && <p className={cn("text-textSecondaryColor body_text_m", normalInter)}>{section.additionalContent}</p>}
        </div>
      ))}
    </div>
  );
}

export default PrivacyPolicy;
